export const isPromoInDateRange = (promo, now = new Date()) => {
  if (!promo.code || !promo.startDate) return false;

  const start = new Date(promo.startDate);
  const end = promo.endDate ? new Date(promo.endDate) : null;

  if (Number.isNaN(start.getTime())) return false;
  if (end && Number.isNaN(end.getTime())) return false;

  if (now < start) return false;
  if (end && now > end) return false;
  return true;
};

export const shouldApplyPromoDiscount = (itemCount, promo) => {
  if (!promo) return false;
  const minItems = promo.minItems ?? 1;
  return itemCount >= minItems;
};

const getPromoDiscountPercent = (promo) => {
  if (promo.discountPercent) return promo.discountPercent;

  const source = promo.hintDiscount ?? promo.label ?? '';
  const match = source.match(/(\d+)\s*%/);
  return match ? `${match[1]}%` : source;
};

export const getPromoBannerLabel = (promo) => {
  const percent = getPromoDiscountPercent(promo);
  const minItems = promo.minItems ?? 1;
  const collections = promo.collections ?? [];

  if (collections.length > 0) {
    const titles = collections.map((c) => c.title).join(', ');
    if (minItems > 1) {
      return `Profitez de ${percent} de réduction sur ${titles} à l'achat d'au moins ${minItems} articles`;
    }
    return `Profitez de ${percent} de réduction sur la collection ${titles}`;
  }

  if (minItems > 1) {
    return `Profitez de ${percent} de réduction à l'achat d'au moins ${minItems} articles`;
  }

  return `Profitez de ${percent} de réduction sur toute la commande`;
};

export const getPromoMinItemsHint = (itemCount, promo) => {
  if (!promo) return null;

  const minItems = promo.minItems ?? 1;
  if (itemCount >= minItems || itemCount <= 0) return null;

  const remaining = minItems - itemCount;
  const percent = getPromoDiscountPercent(promo);
  const articleWord = remaining === 1 ? 'article' : 'articles';

  return `Ajoutez ${remaining} ${articleWord} supplémentaire${remaining > 1 ? 's' : ''} pour profiter de ${percent} de réduction`;
};
